import { PermissionsService } from './../../../core/permissions.service';
import { Note } from './../../../models/note.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-vehicle-card-note',
  templateUrl: './vehicle-card-note.component.html',
  styleUrls: ['./vehicle-card-note.component.scss'],
})
export class VehicleCardNoteComponent implements OnInit {
  @Input() vehicleId: string;
  @Input() note: Note;
  @Input() noteValue: string;
  @Output() onNoteSave = new EventEmitter<string>();

  constructor(public permissionsService: PermissionsService) {}

  ngOnInit() {
    if (!this.noteValue) {
      this.noteValue = '';
    }
    if (!this.note) {
      this.note = {};
    }
  }

  saveNote() {
    this.onNoteSave.emit(this.noteValue);
  }
}
